import styled from "@emotion/styled";
import { switcherTile, switcherTileLogo } from "constants/dimensions";
import { tileShadow } from "constants/effects";

export const Container = styled.div(
  ({ focused }: { focused: boolean }) => `
  background-color: rgba(0, 0, 0, 0.4);
  box-shadow: ${tileShadow};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: ${switcherTile.height}px;
  position: relative;
  width: ${switcherTile.width}px;
  box-sizing: border-box;
  border-radius: ${focused ? 0 : switcherTile.borderRadius}px;
  overflow: hidden;
`
);

export const MediaContainer = styled.div`
  position: absolute;
  width: 100%;
`;

// Quickest workaround I found for TS complaining about `loading` not being intrinsic attribute of `<img>`
export const Image = styled.img<{ loading: string }>`
  display: block;
  width: 100%;
`;

export const Logo = styled.img`
  height: 100%;
  display: block;
`;

export const LogoContainer = styled.div`
  margin-bottom: 2px;
  max-height: ${switcherTileLogo.height}px;
  width: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  padding: 24px;
  position: relative;
  transition: all 0.5s ease-in-out;
  background: url(assets/images/tile-gradient-16-9.png);
  background-size: cover;
`;
